var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 963,
    height: 963,
    viewBox: "0 0 963 963",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M962.5 481.5C962.5 747.149 747.149 962.5 481.5 962.5C215.851 962.5 0.5 747.149 0.5 481.5C0.5 215.851 215.851 0.5 481.5 0.5C747.149 0.5 962.5 215.851 962.5 481.5ZM885.5 481C885.5 704.399 704.399 885.5 481 885.5C257.601 885.5 76.5 704.399 76.5 481C76.5 257.601 257.601 76.5 481 76.5C704.399 76.5 885.5 257.601 885.5 481ZM481 886.5C704.951 886.5 886.5 704.951 886.5 481C886.5 257.049 704.951 75.5 481 75.5C257.049 75.5 75.5 257.049 75.5 481C75.5 704.951 257.049 886.5 481 886.5ZM814.92 481.418C814.92 665.605 665.607 814.918 481.42 814.918C297.233 814.918 147.92 665.605 147.92 481.418C147.92 297.231 297.233 147.918 481.42 147.918C665.607 147.918 814.92 297.231 814.92 481.418ZM481.42 815.918C666.159 815.918 815.92 666.157 815.92 481.418C815.92 296.679 666.159 146.918 481.42 146.918C296.681 146.918 146.92 296.679 146.92 481.418C146.92 666.157 296.681 815.918 481.42 815.918Z",
    stroke: "url(#paint0_linear_974_3510)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_974_3510",
    x1: 291.096,
    y1: 200.597,
    x2: 338.677,
    y2: 794.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3F2FF",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeCircle);
export default __webpack_public_path__ + "static/media/home-circle.072682ad3b2074e73f4208cf6ce34ac5.svg";
export { ForwardRef as ReactComponent };